"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExternalSourceName;
(function (ExternalSourceName) {
    ExternalSourceName["BUDDI_STORE"] = "Buddi - Store";
    ExternalSourceName["BUDVUE"] = "Budvue";
    ExternalSourceName["WOOCOMMERCE"] = "WooCommerce";
    ExternalSourceName["BIGCHIP"] = "BigChip";
    ExternalSourceName["VERDA"] = "Verda";
    ExternalSourceName["FRIENDLY_STRANGER"] = "Friendly Stranger";
    ExternalSourceName["WEEDPOOL"] = "Weedpool";
    ExternalSourceName["BUDDI_ONLINE"] = "Buddi - Online";
    ExternalSourceName["GANJIKA_HOUSE"] = "Ganjika House";
    ExternalSourceName["NIAGARA_HERBALIST"] = "Niagara Herbalist";
    ExternalSourceName["GREENLEAF_DIGITAL_LP"] = "Greenleaf Digital LP";
    ExternalSourceName["WESTCAN_CANNABIS"] = "Westcan Cannabis";
    ExternalSourceName["ALL_IN_ONE_DIGITAL"] = "All In One Digital Ltd.";
    ExternalSourceName["DUTCHIE"] = "Dutchie";
    ExternalSourceName["TEN_NET"] = "10net Managed Solutions Ltd.";
    ExternalSourceName["ONEBUDD"] = "OneBudd";
    ExternalSourceName["INSTALEAF"] = "Instaleaf";
    ExternalSourceName["CANNAED"] = "CannaEd";
    ExternalSourceName["ALPINEIQ"] = "AlpineIQ";
    ExternalSourceName["SOLINK"] = "Solink";
    ExternalSourceName["SAVI"] = "Savi";
    ExternalSourceName["SUPER_ANYTIME"] = "Super Anytime";
    ExternalSourceName["JANE"] = "Jane Technologies";
})(ExternalSourceName = exports.ExternalSourceName || (exports.ExternalSourceName = {}));
var ExternalPermissionName;
(function (ExternalPermissionName) {
    ExternalPermissionName["CAN_CREATE_A_SALE"] = "Can create a sale";
    ExternalPermissionName["CAN_VIEW_SALES"] = "Can view sales";
    ExternalPermissionName["CAN_CANCEL_A_SALE"] = "Can cancel a sale";
    ExternalPermissionName["CAN_CREATE_A_PAYMENT_QUEUE"] = "Can create a payment queue";
    ExternalPermissionName["CAN_VIEW_PAYMENT_QUEUES"] = "Can view payment queues";
    ExternalPermissionName["CAN_UPDATE_A_PAYMENT_QUEUE"] = "Can update a payment queue";
    ExternalPermissionName["CAN_CREATE_PURCHASE_ORDER"] = "Can create purchase order";
    ExternalPermissionName["CAN_VIEW_PURCHASE_ORDERS"] = "Can view purchase orders";
    ExternalPermissionName["CAN_VIEW_POS_LISTINGS"] = "Can view POS listings";
    ExternalPermissionName["CAN_VIEW_PRODUCTS"] = "Can view products";
    ExternalPermissionName["CAN_VIEW_CUSTOMERS"] = "Can view customers";
    ExternalPermissionName["CAN_MANAGE_CUSTOMERS"] = "Can manage customers";
    ExternalPermissionName["CAN_BULK_UPDATE_INVENTORY"] = "Can bulk-update inventory";
    ExternalPermissionName["CAN_VIEW_WHOLESALE_COST"] = "Can view wholesale cost";
    ExternalPermissionName["CAN_UPDATE_CUSTOMER_LOYALTY_POINTS"] = "Can update customer loyalty points";
    ExternalPermissionName["CAN_VIEW_MENUS"] = "Can view menus";
})(ExternalPermissionName = exports.ExternalPermissionName || (exports.ExternalPermissionName = {}));
var ExternalSourceCategoryNames;
(function (ExternalSourceCategoryNames) {
    ExternalSourceCategoryNames["PAYMENT_PROCESSING"] = "Payment processing";
    ExternalSourceCategoryNames["SURVEILLANCE"] = "Surveillance";
    ExternalSourceCategoryNames["CLICK_AND_COLLECT"] = "Click-and-collect";
    ExternalSourceCategoryNames["DIGITAL_SIGNAGE"] = "Digital signage";
    ExternalSourceCategoryNames["ANALYTICS"] = "Analytics";
    ExternalSourceCategoryNames["ONLINE_MENU"] = "Online menu";
})(ExternalSourceCategoryNames = exports.ExternalSourceCategoryNames || (exports.ExternalSourceCategoryNames = {}));
exports.EXTERNAL_SOURCES_CLICK_AND_COLLECT = [ExternalSourceName.BUDDI_ONLINE, ExternalSourceName.DUTCHIE, ExternalSourceName.BUDDI_STORE, ExternalSourceName.SUPER_ANYTIME, ExternalSourceName.JANE];
//# sourceMappingURL=ExternalSource.js.map